import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Remove o prefixo "ROLE_" de uma role
 */
export const formatRole = (role: string): string => {
  if (!role) return '';
  return role.startsWith('ROLE_') ? role.substring(5) : role;
};

/**
 * Formata um array de roles removendo o prefixo "ROLE_"
 */
export const formatRoles = (roles: string[]): string[] => {
  if (!Array.isArray(roles)) return [];
  return roles.map(formatRole);
};
